/**
 * Payer Search feature auto-registration and exports
 *
 * This module automatically registers the payer search feature when imported,
 * making it work seamlessly with both static and dynamic imports.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { payerSearchFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(payerSearchFeature);

// Export store (all store-related exports)
export * from './store';

// Export types
export * from './types';

// Export page component
export { PayerSearchPage } from './PayerSearchPage';

